import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "value-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "section-title" }
const _hoisted_4 = { class: "section-subtitle" }
const _hoisted_5 = { class: "value-cards" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ValueCard = _resolveComponent("ValueCard")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('home.coreFeatures')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('home.comprehensiveSolution')), 1),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.valueCards, (item, index) => {
          return (_openBlock(), _createBlock(_component_ValueCard, {
            key: index,
            icon: item.icon,
            title: item.title,
            description: item.description,
            "action-text": item.actionText,
            onActionClick: ($event: any) => ($setup.handleActionClick(item.action))
          }, null, 8, ["icon", "title", "description", "action-text", "onActionClick"]))
        }), 128))
      ])
    ])
  ]))
}